<template>
  <transition name="from-center">
    <div class="center-modal"
         :style="{ maxWidth: width + 'px' }">
      <i class="close-button xi-close"
         @click="$emit('close')"></i>
      <div class="side-modal-wrap">
        <transition name="fade">
          <slot></slot>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UiCenterModal',
  props: {
    width: {
      type: Number,
      default: 600
    }
  }
}
</script>

<style scoped lang="scss">
.center-modal {
  z-index: 999999999;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100vh;
  width: calc(100% - 32px);
  max-width: 500px;
  max-height: 500px;
  overflow: auto;
  background-color: $white;
  border-radius: 10px;
  box-shadow: -8px 0 15px 0 rgba(0, 0, 0, 0.16);

  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 55;
    background-color: $light;
    color: $gray;
    border-radius: 20px;
    padding: 3px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s ease,
    color 0.3s ease;

    &:hover {
      background-color: $red;
      color: $white;
    }
  }

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    box-shadow: inset 0 0 10px 10px $gray;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb:hover {
    box-shadow: inset 0 0 10px 10px $gray;
  }
}
</style>